import React, { useState, useEffect } from 'react';
import { Box, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CiLayout from './ciLayout';
import ProcessTable from './processTable';

/**
 * Componente que exibe a tabela de processos para clientes.
 * @param {Object} props - Propriedades recebidas pelo componente.
 * @param {Object} props.response - Resposta da API com os dados do usuário.
 */
function CiCliente({ response }) {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [filteredRows, setFilteredRows] = useState([]);

    useEffect(() => {
        if (response.auth === true) {
            setRows(response.resp);
            setFilteredRows(response.resp);
        }
    }, [response]);

    useEffect(() => {
        setFilteredRows(
            rows.filter((row) =>
                Object.values(row).some((value) =>
                    String(value).toLowerCase().includes(searchText.toLowerCase())
                )
            )
        );
    }, [searchText, rows]);

    /**
     * Atualiza o estado do texto de pesquisa conforme o usuário digita.
     * @param {Object} event - Evento de mudança no campo de pesquisa.
     */
    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    // Definição das colunas para clientes (sem a coluna de ação)
    const columns = [
        { field: 'id', headerName: '#', width: 70 },
        {
            field: 'processo',
            headerName: 'Processo',
            width: 150,
            sortable: true,
            renderCell: (params) => (
                <div
                    onClick={() => navigate(`/ci/pagamentos/${params.row.id}`)}
                    style={{ cursor: 'pointer', color: '#1a76d2' }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'pasta',
            headerName: 'Pasta',
            width: 150,
            renderCell: (params) => (
                <div
                    onClick={() => navigate(`/ci/pagamentos/${params.row.id}`)}
                    style={{ cursor: 'pointer', color: '#1a76d2' }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'data_inicio',
            headerName: 'Início',
            width: 110,
            renderCell: (params) => (
                <div
                    onClick={() => navigate(`/ci/pagamentos/${params.row.id}`)}
                    style={{ cursor: 'pointer', color: '#1a76d2' }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'observacao',
            headerName: 'Observação',
            width: 200,
            renderCell: (params) => (
                <div
                    onClick={() => navigate(`/ci/pagamentos/${params.row.id}`)}
                    style={{ cursor: 'pointer', color: '#1a76d2' }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'nome_client',
            headerName: 'Cliente',
            width: 150,
            renderCell: (params) => (
                <div
                    onClick={() => navigate(`/ci/pagamentos/${params.row.id}`)}
                    style={{ cursor: 'pointer', color: '#1a76d2' }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'advogado',
            headerName: 'Adv/R',
            width: 150,
            renderCell: (params) => (
                <div
                    onClick={() => navigate(`/ci/pagamentos/${params.row.id}`)}
                    style={{ cursor: 'pointer', color: '#1a76d2' }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'reu',
            headerName: 'Réu',
            width: 150,
            renderCell: (params) => (
                <div
                    onClick={() => navigate(`/ci/pagamentos/${params.row.id}`)}
                    style={{ cursor: 'pointer', color: '#1a76d2' }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'advAutor',
            headerName: 'Adv/A',
            width: 150,
            renderCell: (params) => (
                <div
                    onClick={() => navigate(`/ci/pagamentos/${params.row.id}`)}
                    style={{ cursor: 'pointer', color: '#1a76d2' }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'autor',
            headerName: 'Autor',
            width: 150,
            renderCell: (params) => (
                <div
                    onClick={() => navigate(`/ci/pagamentos/${params.row.id}`)}
                    style={{ cursor: 'pointer', color: '#1a76d2' }}
                >
                    {params.value}
                </div>
            ),
        },
    ];

    return (
        <CiLayout isAdmin={false}>
            <div className="row" style={{ marginTop: 20 }}>
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Consultar Processos</h3>
                        </div>
                        <div className="card-body">
                            {/* Campo de pesquisa para clientes */}
                            <Box
                                display="flex"
                                justifyContent="flex-end"
                                alignItems="center"
                                mb={2}
                            >
                                <TextField
                                    label="Pesquisar"
                                    variant="outlined"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    style={{ maxWidth: '300px' }}
                                />
                            </Box>
                            {/* Tabela de processos para clientes */}
                            <ProcessTable
                                rows={filteredRows}
                                columns={columns}
                                onRowClick={(params) => navigate(`/ci/pagamentos/${params.id}`)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </CiLayout>
    );
}

export default CiCliente;
